export default "__VITE_ASSET__eUkNGdvF__"